<style scoped>
.el-col-5 {
  width: 30%;
}
.el-col-8,
.el-col-12 {
  /* display: flex; */
}
.chooseBox {
  display: flex;
  /* justify-content: center; */
  /* margin-top: 30px; */
}
.upload-txt {
  line-height: 6px;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.txt-color {
  text-decoration: none;
}
.clear-person {
  color: #4fa1a4;
  float: right;
  margin-right: 20px;
  text-decoration: underline;
  cursor: pointer;
}
.search-area-div {
  flex-shrink: 0;
  width: 120px;
  text-align: right;
}
.form-box {
  display: flex;
  flex-wrap: wrap;
}
.form-box .form-list {
  display: flex;
  width: 48%;
  margin-bottom: 20px;
  padding: 0 2%;
  box-sizing: border-box;
}
.form-box .form-list label {
  width: 120px;
  flex-shrink: 0;
  text-align: right;
  line-height: 36px;
}
.form-box .form-list label span {
  color: red;
}
.form-box .form-list .form-input {
  flex: 1;
  width: 100%;
}
.form-box .form-list .form-input p {
  color: #4fa1a4;
  text-align: left;
  margin-bottom: 0 !important;
}
.W250 {
  width: 250px;
}
.upload-pic /deep/ .el-form-item__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.step-box {
  margin-bottom: 20px;
}
.btn-box {
  display: flex;
  justify-content: space-between;
  padding-right: 20px;
}
.result-tip {
  font-size: 12px;
  line-height: 22px;
  color: #ff991c;
  text-align: left;
  padding-left: 142px;
  margin-bottom: 15px;
}
.ipt-sty {
  flex: 1;
}
.ipt-sty-2 {
  width: 74% !important;
}
.el-col-6 {
  display: flex;
  /* margin-bottom: 15px; */
}
.content-main-box{
  height: 100%;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <div class="step-box">
        <el-steps :active="active" align-center>
          <el-step title="计算留存"></el-step>
          <el-step title="计算考核"></el-step>
        </el-steps>
      </div>
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">姓名/手机号：</div>
          <el-input size="mini" v-model="page.keyword" clearable style="flex: 1" placeholder="请输入姓名/手机号"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">药企名称：</div>
          <el-select
          size="mini"
            v-model="page.tenantGuid"
            style="flex: 1"
            placeholder="请选择药企名称"
            filterable
            @change="tenantChangeTabel"
          >
            <el-option
              v-for="item in companyList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">
            <el-tooltip class="item" effect="dark" content="本月核销金额<实际下发金额" placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
            金额是否异常：
          </div>
          <el-select size="mini" v-model="page.isMoneyUnusual" placeholder="请选择" style="flex: 1">
            <el-option v-for="item in isNotOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore" :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <div class="search-block mt15" v-show="showMore">
          <el-col :span="6">
            <div class="search-area-div">部门名称：</div>
            <el-select
              size="mini"
              v-model="page.organisationName"
              placeholder="请选择"
              style="flex: 1"
              clearable
              filterable
              collapse-tags
              @focus="getOrganisationProgress(1)"
            >
              <el-option
                v-for="item in organisationList"
                :key="item.guid"
                :label="item.organisationName"
                :value="item.organisationName"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">核算月：</div>
            <el-date-picker
             size="mini"
              style="flex: 1"
              value-format="yyyy-MM"
              v-model="page.accountMonth"
              type="month"
              placeholder="选择月"
              @change="getCycleData"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">账单周期：</div>
            <el-select size="mini" v-model="page.billCycle" style="flex: 1" placeholder="请选择" @focus="getCycleFocus()" filterable>
              <el-option v-for="item in cycleData" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">是否最后一次：</div>
            <el-select size="mini" v-model="page.isLastPart" style="flex: 1" placeholder="请选择" filterable>
              <el-option v-for="item in isNotOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </div>
      </el-row>
    </div>
    <div class="button-area btn-box">
      <div>
        <el-button size="mini" type="info" @click="calcAll">计算留存</el-button>
        <el-button size="mini" type="info" @click="calcAll(1)">查看进度</el-button>
        <el-button size="mini" type="info" @click="report">导出</el-button>
        <!-- <el-button size="mini" type="info" @click="dialogVisibleIIIClick(1)">打印</el-button> -->
      </div>
      <div>
        <el-button size="mini" type="info" @click="dialogVisibleIIIClick(2)">清除本月数据</el-button>
        <el-button size="mini" type="info" @click="nextStep">下一步</el-button>
      </div>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'" v-loading.fullscreen.lock="fullscreenLoading" >
      <el-table :data="tableData" stripe border style="width: 100%" :height="tableHeight">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          label="公司名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
          min-width="240"
        >
        </el-table-column>
        <el-table-column
          prop="organisationName"
          label="所属组织"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="140"
        ></el-table-column>
        <el-table-column
          prop="staffName"
          label="业务员"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="100"
        ></el-table-column>
        <el-table-column
          prop="mobileNo"
          label="手机号"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="accountMonth"
          label="核算月"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="90"
        >
          <template slot-scope="scope">{{ scope.row.accountMonth | getMonth }}</template>
        </el-table-column>
        <el-table-column
          prop="billCycle"
          label="账单周期"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="90"
        >
          <template slot-scope="scope">{{ scope.row.billCycle || "全部" }}</template>
        </el-table-column>
        <el-table-column
          prop="realGiveMoney"
          label="本月实际下发金额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="180"
        >
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="本月账单的金额，包含底薪、绩效和提成*对应任务单价"
              placement="bottom"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
            本月实际下发金额(元)
          </template>
          <template slot-scope="scope">{{ scope.row.realGiveMoney | numDigit | numFmt }}</template>
        </el-table-column>
        <el-table-column
          prop="finishTaskMoney"
          label="本月核销任务额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="180"
        >
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="与本月实际下发金额相匹配的任务金额，即匹配的任务量*对应任务单价"
              placement="bottom"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
            本月核销任务额(元)
          </template>
          <template slot-scope="scope">{{ scope.row.finishTaskMoney | numDigit | numFmt }}</template>
        </el-table-column>
        <el-table-column
          prop="lastMonthMoney"
          label="上期留存金额(元）"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="150"
        >
          <template slot-scope="scope">{{ scope.row.lastMonthMoney | numDigit | numFmt }}</template>
        </el-table-column>
        <el-table-column
          prop="allTaskMoney"
          label="本月实际完成额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="170"
        >
          <template slot-scope="scope">{{ scope.row.allTaskMoney | numDigit | numFmt }}</template>
        </el-table-column>
        <el-table-column
          prop="realTaskMoney"
          label="本月质量任务额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="180"
        >
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="本月实际完成的任务量（不同任务类型）*对应任务单价"
              placement="bottom"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
            本月质量任务额(元)
          </template>
          <template slot-scope="scope">{{ scope.row.realTaskMoney | numDigit | numFmt }}</template>
        </el-table-column>
        <el-table-column
          prop="lastSurplusMoney"
          label="上月结余金额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">{{ scope.row.lastSurplusMoney | numDigit | numFmt }}</template>
        </el-table-column>
        <el-table-column
          prop="realTaskMoney"
          label="本月结余金额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">{{ scope.row.surplusMoney | numDigit | numFmt }}</template>
        </el-table-column>
        <el-table-column
          prop="surplusMoney"
          label="本月留存任务金额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">{{ scope.row.leftTaskMoney | numDigit | numFmt }}</template>
        </el-table-column>
        <el-table-column
          prop="isLastPart"
          label="是否最后一次"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="110"
        >
          <template slot-scope="scope">{{ scope.row.isLastPart == 'Y' ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column
          prop="billCycleSeq"
          label="计算周期顺序"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="110"
        >
          <template slot-scope="scope">{{ scope.row.billCycleSeq  || '-'}}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" fixed="right" width="120px;">
          <template slot-scope="scope">
            <a class="txt-color" @click="delData(scope.row)">清除本月留存</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <!-- 核算月 药企 -->
    <el-dialog title="留存计算" :visible.sync="dialogVisibleI" width="650px" :close-on-click-modal="false">
      <template v-if="dialogVisibleI">
        <el-form label-width="140px" class="demo-ruleForm">
          <el-form-item required>
            <span slot="label">药企名称：</span>
            <el-select
              v-model="calForm.tenantGuid"
              filterable
              placeholder="请选择"
              class="ipt-sty w80f fl"
              @change="tenantChange"
            >
              <el-option
                v-for="item in companyList"
                :key="item.sendTenantGuid"
                :label="item.sendTenantName"
                :value="item.sendTenantGuid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <div class="result-tip">{{ resultTip }}</div> -->
          <el-form-item required>
            <span slot="label">任务类型：</span>
            <el-select v-model="calForm.taskType" filterable placeholder="请选择" class="ipt-sty w80f fl">
              <el-option v-for="item in taskOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item >
            <span slot="label">任务继承：
              <el-tooltip class="item" effect="dark" content="将下级分配的任务转移给上级" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
            <el-select v-model="calForm.isTaskMove" filterable placeholder="请选择" class="ipt-sty w80f fl" >
              <el-option
                v-for="item in isTaskMoveOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item required>
            <span slot="label">组织名称：</span>
            <el-select
              v-model="calForm.organisationGuid"
              filterable
              placeholder="请选择"
              class="ipt-sty w80f fl"
              @change="organisationChange"
              @focus="getOrganisation()"
            >
              <el-option
                v-for="item in organisationList"
                :key="item.guid"
                :label="item.organisationName"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item required>
            <span slot="label">核算月份：</span>
            <el-date-picker
              class="ipt-sty w80f fl"
              value-format="yyyy-MM"
              v-model="calForm.accountMonth"
              type="month"
              placeholder="选择月"
            >
            </el-date-picker>
          </el-form-item>
          <!-- 新增字段 -->
          <el-form-item required>
            <span slot="label">是否分月下发：</span>
            <el-select v-model="calForm.isPart" filterable placeholder="请选择" class="ipt-sty w80f fl" @change="isPartChange">
              <el-option v-for="item in isNotOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item required v-if="calForm.isPart == 'Y'">
            <span slot="label">账单周期：</span>
            <el-select v-model="calForm.billCycle" filterable placeholder="请选择" class="ipt-sty w80f fl" >
              <el-option v-for="item in billCycleOption" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item required v-if="calForm.isPart == 'Y'">
            <span slot="label">是否最后一次：</span>
            <el-select v-model="calForm.isLastPart" filterable placeholder="请选择" class="ipt-sty w80f fl">
              <el-option v-for="item in isNotOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 新增结束 -->
          <el-form-item>
            <span slot="label">姓名：</span>
            <el-select
              v-model="staffGuidList"
              filterable
              multiple
              clearable
              placeholder="请选择"
              class="ipt-sty w80f fl"
              v-loading="staffLoading"
            >
              <el-option v-for="item in staffList" :key="item.guid" :label="item.staffName" :value="item.guid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" plain @click="dialogVisibleI = false">取 消</el-button>
          <el-button size="medium" type="info" @click="bitchProduce">计 算</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 查看进度 -->
    <el-dialog title="查看进度" :visible.sync="dialogVisibleII" width="1000px" :close-on-click-modal="false">
      <el-form label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item>
            <span slot="label">药企名称</span>
            <el-select
              v-model="pageProgress.tenantGuid"
              placeholder="请选择药企名称"
              class="ipt-sty-2 fl"
              @change="tenantChangeProgress"
              filterable
            >
              <el-option
                v-for="item in companyList"
                :key="item.sendTenantGuid"
                :label="item.sendTenantName"
                :value="item.sendTenantGuid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <span slot="label">组织名称</span>
            <el-select
              v-model="pageProgress.organisationGuid"
              placeholder="请选择"
              class="ipt-sty-2 fl"
              clearable
              filterable
              collapse-tags
              @focus="getOrganisationProgress()"
            >
              <el-option
                v-for="item in organisationList"
                :key="item.guid"
                :label="item.organisationName"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <span slot="label">核算月</span>
            <el-date-picker
              class="ipt-sty-2 fl"
              value-format="yyyy-MM"
              v-model="pageProgress.accountMonth"
              type="month"
              placeholder="选择月"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-button size="mini" type="info" @click="getProgressData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptyProgress">清空</el-button>
        </el-col>
      </el-row>
      </el-form>
      <template>
        <div class="back-color-fff content-main-box" style="height:300px">
          <el-table
            :data="progressData"
            border
            style="width: 100%;"
            :height="300"
            v-loading="progressLoading"
          >
            <el-table-column label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="tenantName" label="公司名称" header-align="center" align="left" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="organisationName"
              label="组织名称"
              header-align="center"
              align="left"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="accountMonth"
              label="核算月"
              width="90"
              header-align="center"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">{{ scope.row.accountMonth | getMonth }}</template>
            </el-table-column>
            <el-table-column prop="name" label="计算进度" header-align="center" align="left" width="90">
              <template slot-scope="scope">{{ scope.row.state == 'F' ? '已完成' : '执行中' }}</template>
            </el-table-column>
            <el-table-column prop="endTime" label="计算完成时间" width="150" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.endTime | getTimeDate }}</template>
            </el-table-column>
            <el-table-column prop="result" label="耗时(秒)" width="80" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.useSecond }}</template>
            </el-table-column>
            <el-table-column
              prop="createUserName"
              label="提交人"
              width="110"
              header-align="center"
              align="left"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="createTime" label="提交时间" width="150" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
            </el-table-column>
            <el-table-column prop="result" label="计算结果" width="110" header-align="center" align="left" show-overflow-tooltip >
              <template slot-scope="scope">{{ scope.row.result || '-' }}</template>
            </el-table-column>
          </el-table>
        </div>
      </template>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChangeProgress"
        @current-change="handleCurrentChangeProgress"
        :page-sizes="[10,20,50,100, 200]"
        :current-page="pageProgress.pageIndex"
        :page-size="pageProgress.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageProgress.totalRows"
      >
      </el-pagination>
    </el-dialog>
    <!-- 打印 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisibleIII" width="650px" :close-on-click-modal="false">
      <template v-if="dialogVisibleIII">
        <el-form label-width="140px" class="demo-ruleForm">
          <el-form-item required>
            <span slot="label">药企名称：</span>
            <el-select
              v-model="printForm.tenantGuid"
              filterable
              placeholder="请选择"
              class="ipt-sty w80f fl"
              @change="tenantChange"
            >
              <el-option
                v-for="item in companyList"
                :key="item.sendTenantGuid"
                :label="item.sendTenantName"
                :value="item.sendTenantGuid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :required="dialogType == 1 ? false : true">
            <span slot="label">组织名称：</span>
            <el-select
              v-model="printForm.organisationGuid"
              filterable
              clearable
              placeholder="请选择"
              class="ipt-sty w80f fl"
              @focus="getOrganisation(1)"
            >
              <el-option
                v-for="item in organisationList"
                :key="item.guid"
                :label="item.organisationName"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item required>
            <span slot="label">核算月份：</span>
            <el-date-picker
              class="ipt-sty w80f fl"
              value-format="yyyy-MM"
              v-model="printForm.accountMonth"
              type="month"
              placeholder="选择月"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" plain @click="dialogVisibleIII = false">取 消</el-button>
          <el-button size="medium" type="info" @click="exportPrint">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <printDialogCheck
      v-if="printData && showPrint"
      :showPrintDialog.sync="showPrint"
      :printData="printData"
      @closePrint="closePrint"
      :printType="1"
    ></printDialogCheck>
  </div>
</template>
<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import printDialogCheck from '@/components/printDialogCheck.vue';
import getTenantDetail from '../mixins/getTenantDetail';
import { ServiceProviderTypeEnum } from '../mixins/getTenantDetail'
export default {
  components: {
    printDialogCheck,
  },
  mixins:[getTenantDetail],
  data() {
    return {
      ServiceProviderTypeEnum,
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 340,
      contentMainHeight: window.innerHeight - 280,
      searchShow: false,
      costDetail: {},
      showPrint: true,
      dialogVisible: false,
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      configBlackParm: '',
      input: '',
      title: '添加账单',
      dialogFormVisible: false,
      fullscreenLoading: false,
      tableLoading: false,
      tableWrapLoading: false,
      value2: '',
      companyList: [], //公司选择\
      staffList: [], //人员列表
      idCode: '', //身份证号
      mobileNo: '', //手机号
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        keyword: '',
        organisationName: '',
        accountMonth: '',
        isMoneyUnusual: '',
        billCycle:'',
        isLastPart:'',
      },
      guid: '',
      count: '', //打卡次数
      fileList: [], //文件
      tableData: [],
      multipleSelection: [],
      staffLoading: false,
      dialogVisibleI: false,
      dialogVisibleII: false,
      dialogVisibleIII: false,
      calForm: {
        tenantGuid: '',
        tenantName: '',
        organisationGuid: '',
        accountMonth: '',
        taskType: '',
        isPart:'',
        billCycle:'',
        isLastPart:''
        // isTaskMove:''//任务转移
      },
      taskOption: [
        // { label: '所有任务', value: '0' },
        { label: '合格任务', value: '1' },
        { label: '合格和部分合格任务', value: '2' },
      ],
      isTaskMoveOption: [
        { label: '任务转移', value: '1' },
        { label: '任务不转移', value: '0' },
      ],
      billCycleOption: ['一期', '二期', '三期', '四期', '五期', '六期', '七期', '八期', '九期', '十期', '十一期', '十二期', '十三期', '十四期', '十五期', '十六期', '十七期', '十八期', '十九期', '二十期', '二十一期', '二十二期', '二十三期', '二十四期', '二十五期', '二十六期', '二十七期', '二十八期', '二十九期', '三十期'],
      staffGuidList: [],
      accountMonthList: [],
      tenantGuidList: [],
      organisationList: [],
      staffList: [],
      subTitle: '',
      active: 0,
      isNotOption: [
        { label: '是', value: 'Y' },
        { label: '否', value: 'N' },
      ],
      resultTip: '',
      progressData: [],
      pageProgress: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        taskType: '1',
        organisationGuid: '',
        accountMonth: '',
      },
      organisationList: [],
      progressLoading: false,
      // 打印
      printForm: {
        tenantGuid: null,
        organisationGuid: null,
        accountMonth: null,
      },
      printData: null,
      dialogTitle:'打印',
      dialogType:1, //1打印 2本月期数
      cycleData:[]
    };
  },
  watch:{
    showMore(val, oldVal) {
      if(val) {
        // 509 
        // 470
        this.tableHeight = window.innerHeight - 380;
        this.contentMainHeight=window.innerHeight - 359;
        return;
      }
      if(!val) {
        this.tableHeight = window.innerHeight - 340;
        this.contentMainHeight = window.innerHeight - 280;
        return;
      }
    }
  },
  async created() {
    await this.Mixins_getServiceProviderType();
    // 列表
    this.getCompany();
  },
  destroyed() {
    sessionStorage.removeItem('staffDataDetail');
  },
  methods: {
    calcReverse(NUM) {
      return NUM == 0 ? '0.00' : NUM > 0 ? '-' + Number(NUM).toFixed(2) : Number(Math.abs(NUM)).toFixed(2);
    },
    calcAll(type) {
      if (type == 1) {
        this.dialogVisibleII = true;
        this.getProgressData(true);
      } else {
        this.dialogVisibleI = true;
        this.resultTip = '';
      }
    },
    nextStep() {
      this.$router.push('/checkTaskList?productGuid='+this.$route.query.productGuid);
    },
    getMonthStartOrEnd(type, monthDate) {
      let time = null;
      if (type == 1) {
        time = this.$moment(monthDate).startOf('month').valueOf();
      } else {
        time = this.$moment(monthDate).endOf('month').valueOf();
      }
      return time;
    },
    empty() {
      let self = this;
      self.page.pageIndex = 1;
      self.page.keyword = '';
      self.page.organisationName = '';
      self.page.accountMonth = '';
      self.page.tenantGuid = '';
      self.page.isMoneyUnusual = '';
      self.page.billCycle ='';
      self.page.isLastPart = '';
      self.cycleData = [];
      self.getData(true);
    },
    emptyProgress() {
      (this.pageProgress = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        taskType: '1',
        organisationGuid: '',
        accountMonth: '',
      }),
        this.getProgressData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      let query = JSON.parse(JSON.stringify(self.page));
      if (query.accountMonth) {
        query.accountMonth = query.accountMonth.replace('-', '');
      }
      query.billCycle = query.billCycle == '全部' ? null : query.billCycle;
      this.fullscreenLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/get-belong-account-month`, query)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data.records) {
              self.tableData = res.data.data.records;
              self.page.totalPage = res.data.data.totalPages;
              self.page.totalRows = res.data.data.totalRows;
            } else {
              self.tableData = [];
              self.page.totalPage = 0;
              self.page.totalRows = 0;
            }
          } else {
            self.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          self.tableWrapLoading = false;
        });
    },
    // 导出政策
    report(){
      let that = this;
      that.fullscreenLoading = true;
      
      let query = JSON.parse(JSON.stringify(that.page));
      if (query.accountMonth) {
        query.accountMonth = query.accountMonth.replace('-', '');
      }
      query.billCycle = query.billCycle == '全部' ? null : query.billCycle;
      that.api.postJsonD(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/export-task-left`, query).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        console.log('blob',blob);
        let str='留存数据_'
        let fileName = str + this.$moment(new Date()).format('YYYYMMDD');
        let objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = fileName;
        link.href = objectUrl;
        link.click();
        that.fullscreenLoading = false;
      });
        
      
    }, 
    tenantChange(val) {
      if (val) {
        this.calForm.organisationGuid = '';
        this.calForm.organisationName = '';
        this.staffGuidList = [];
        this.companyList.forEach((i) => {
          if (i.sendTenantGuid == val) {
            this.calForm.tenantName = i.sendTenantName;
          }
        });
        this.getOrganisationList(val);
        // this.checkTenantState(val);
      }
    },
    tenantChangeTabel(val) {
      if (val) {
        this.getOrganisationList(val);
        this.getCycleData();
      }else{
        this.cycleData = [];
        this.page.billCycle = null;
      }
    },
    tenantChangeProgress(val) {
      if (val) {
        this.getOrganisationList(val);
      }
    },
    //获取组织
    getOrganisationList(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
        sendTenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getOrganisation(type) {
      if (!this.calForm.tenantGuid && type !== 1) {
        this.$message.error('请选择药企名称后再选择部门!');
        return;
      }
    },
    getCycleFocus(){
      if (!this.page.tenantGuid) {
        this.$message.error('请选择药企名称!');
        this.cycleData = [];
        return;
      }
      if (!this.page.accountMonth) {
        this.$message.error('请选择核算月!');
        this.cycleData = [];
        return;
      }
    },
    //获取周期
    getCycleData(val) {
      let self = this;
      if(!val){
        this.page.billCycle = null;
        return
      }
      if (!this.page.tenantGuid) {
        // this.$message.error('请选择药企名称!');
        return;
      }
      if (!this.page.accountMonth) {
        // this.$message.error('请选择核算月!');
        return;
      }
      
      let accountMonth = JSON.parse(JSON.stringify(this.page.accountMonth));
      accountMonth = accountMonth.replace('-','');
      self.api.postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/get-bill-cycle?accountMonth=${accountMonth}&tenantGuid=${this.page.tenantGuid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.cycleData = res.data.data || [];
          if(self.cycleData && self.cycleData.length > 0){
            self.cycleData.forEach((i,index)=>{
              if(!i){
                self.cycleData[index] = '全部';
              }
            })
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    isPartChange(val){
      if(val){
        this.calForm.billCycle = null;
        this.calForm.isLastPart = null;
      }
    },
    //1 打印 2清除期数
    dialogVisibleIIIClick(type){
      this.dialogTitle = type == 1 ? '打印' : '清除本月期数';
      this.dialogVisibleIII = true;
      this.dialogType = type;
    },
    //查看进度
    getProgressData(flg) {
      let self = this;
      if (flg) {
        self.pageProgress.pageIndex = 1;
      }
      let query = JSON.parse(JSON.stringify(self.pageProgress));
      if (query.accountMonth) {
        query.accountMonth = query.accountMonth.replace('-', '');
      }
      this.progressLoading = true;
      query.taskType = '1'
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/kafka-job/data/get-list`, query)
        .then((res) => {
          this.progressLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data.records) {
              self.progressData = res.data.data.records;
              self.pageProgress.totalPage = res.data.data.totalPages;
              self.pageProgress.totalRows = res.data.data.totalRows;
            } else {
              self.progressData = [];
              self.pageProgress.totalPage = 0;
              self.pageProgress.totalRows = 0;
            }
          } else {
            self.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          self.tableWrapLoading = false;
        });
    },
    //企业计算状态
    checkTenantState(val) {
      let self = this;
      self.api
        .postCan(`/${serverConfig.msSalesPerformService}/kafka-job/data/get-job-msg?tenantGuid=${val}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.resultTip = res.data.data;
            } else {
              self.resultTip = '';
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    organisationChange(val) {
      if (val) {
        this.staffGuidList = [];
        this.organisationList.forEach((i) => {
          if (i.guid == val) {
            this.calForm.organisationName = i.organisationName;
          }
        });
        this.getStaff();
      }
    },

    //获取人员
    getStaff(type) {
      let self = this;
      if (!this.calForm.tenantGuid || !this.calForm.organisationGuid) {
        this.$message.error('请先选择药企和组织！');
        return;
      }
      let query = {
        pageIndex: 1,
        pageSize: -1,
        bizState: 'Y',
        containChildOrganisationGuid: this.calForm.organisationGuid,
        tenantGuid: this.calForm.tenantGuid,
      };
      this.staffLoading = true;
      // return new Promise((resolve, reject) => {
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.staffList = res.data.data.records;
          self.staffLoading = false;
        } else {
          self.$message.error(res.data.msg);
        }
      });
      // });
    },
    //获取公司
    getCompany() {
      let self = this;
      let relType = null;
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        if (serviceProviderType == this.ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR) {
          relType = '123'; // 写死
        }
      } catch (error) { 
        console.log('error',error);
      }
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
        relType,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.companyList = res.data.data;
            this.getData(false);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取组织
    getOrganisationList(tenantGuid) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: tenantGuid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getOrganisationProgress(type) {
      if (!this.page.tenantGuid && type == 1) {
        this.$message.error('请选择药企名称!');
        return;
      }
      if (!this.pageProgress.tenantGuid && type !== 1) {
        this.$message.error('请选择药企名称!');
        return;
      }
    },
    //计算
    bitchProduce() {
      if (!this.calForm.tenantGuid) {
        this.$message.error('请选择药企名称');
        return;
      }
      if (!this.calForm.taskType) {
        this.$message.error('请选择任务类型');
        return;
      }
      // if (!this.calForm.isTaskMove) {
      //   this.$message.error('请选择任务继承');
      //   return;
      // }
      if (!this.calForm.organisationGuid) {
        this.$message.error('请选择组织名称');
        return;
      }
      if (!this.calForm.accountMonth) {
        this.$message.error('请选择核算月份');
        return;
      }
      if (!this.calForm.isPart) {
        this.$message.error('请选择是否分月下发');
        return;
      }
      if (this.calForm.isPart === 'Y' && !this.calForm.billCycle) {
        this.$message.error('请选择账单周期');
        return;
      }
      if (this.calForm.isPart === 'Y' && !this.calForm.isLastPart) {
        this.$message.error('请选择是否最后一次');
        return;
      }
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let self = this;
      let req = {
        tenantGuid: this.calForm.tenantGuid,
        tenantName: this.calForm.tenantName,
        organisationGuid: this.calForm.organisationGuid,
        organisationName: this.calForm.organisationName,
        taskType: this.calForm.taskType,
        accountMonth: this.calForm.accountMonth.replace('-', ''),
        staffGuidList: this.staffGuidList,
        isPart:this.calForm.isPart,
        billCycle:this.calForm.billCycle,
        isLastPart:this.calForm.isLastPart,
        // isTaskMove:this.calForm.isTaskMove
        createUserName: userInfo.staffName,
        createUserId: userInfo.userGuid,
      };
      self.dialogVisibleI = false;
      self.fullscreenLoading = true;
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/staff-salary-task/data/update-belong-account-month-kafka`,
          req,
        )
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.warning(res.data.data);
            self.calForm = {
              accountMonth: '',
              tenantGuid: '',
              tenantName: '',
              organisationGuid: '',
              organisationName: '',
              // isTaskMove:'',
              taskType: '',
              isPart:'',
              billCycle:'',
              isLastPart:''
            };
            self.staffGuidList = [];
            self.getData();
            self.resultTip = '';
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    isAllEqual(array) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value !== array[0];
        });
      } else {
        return true;
      }
    },
    //打印/清除期数
    exportPrint() {
      if (!this.printForm.tenantGuid) {
        this.$message.error('请选择药企名称');
        return;
      }
      if(!this.printForm.organisationGuid && this.dialogType !== 1){
        this.$message.error('请选择组织');
        return;
      }
      if (!this.printForm.accountMonth) {
        this.$message.error('请选择核算月份');
        return;
      }
      let self = this;
      let req = {
        tenantGuid: this.printForm.tenantGuid,
        organisationGuid: this.printForm.organisationGuid,
        accountMonth: this.printForm.accountMonth.replace('-', ''),
      };
      self.dialogVisibleIII = false;
      self.fullscreenLoading = true;
      if(this.dialogType == 1){
        self.api
        .postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/get-left-settlement`, req)
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.printData = res.data.data;
              self.showPrint = true;
            } else {
              self.$message.warning('暂无数据');
            }
            // self.printForm = {
            //   accountMonth: '',
            //   tenantGuid: '',
            //   organisationGuid: '',
            // };
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }else{
        self.api
        .postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/delete-bill-cycle`, req)
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success(res.data.data);
            self.getData(true);
            self.printForm = {
              accountMonth: '',
              tenantGuid: '',
              organisationGuid: '',
            };
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }
      
    },
    //打印
    closePrint() {
      this.showPrint = false;
    },
    delData(row) {
      let self = this;
      this.$confirm('此操作将清除本月留存,是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(
              `/${serverConfig.msSalesPerformService}/staff-salary-task/data/delete-belong-account-month?accountMonth=${row.accountMonth}&staffGuid=${row.staffGuid}&tenantGuid=${row.tenantGuid}`,
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success(res.data.data);
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    handleSizeChangeProgress(val) {
      let self = this;
      self.pageProgress.pageSize = val;
      this.getProgressData();
    },
    handleCurrentChangeProgress(val) {
      let self = this;
      self.pageProgress.pageIndex = val;
      this.getProgressData();
    },
  },
};
</script>
